import PropTypes from 'prop-types';
import React from 'react';
import ActionInfo from 'material-ui/svg-icons/action/info-outline';

const Note = props => {
  const {children} = props;
  return (<span><ActionInfo style = {{verticalAlign: 'middle', position: 'relative', bottom: 2}}/> {children}</span>);
};
export default Note;

Note.propTypes = {
  children: PropTypes.node.isRequired,
};